<script>
  export default {
    name: 'app-store-grid-row-item',

    props: {
      app: {
        type: Object,
        required: true
      }
    }
  }
</script>

<template>
  <b-col sm="2" class="grid-row-item">
    <router-link :to="`/store/${app.id}`">
      <img :src="app.icon" alt="" class="icon hover-drop-shadow">
      <h6>{{ app.name }}</h6>
      <span>{{ app.subtitle }}</span>
    </router-link>
  </b-col>
</template>

<style src="./AppStoreGridRowItem.scss" lang="scss" scoped></style>
